var map = {
	"./decidim/avatar-multiuser.png": 6872,
	"./decidim/brands/facebook.svg": 98918,
	"./decidim/brands/google.svg": 37767,
	"./decidim/brands/twitter-x.svg": 74540,
	"./decidim/cc-badge.png": 17298,
	"./decidim/decidim-logo.svg": 81914,
	"./decidim/default-avatar.svg": 3014,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 80954,
	"./decidim/icons.svg": 80713,
	"./decidim/pattern.png": 18918,
	"./decidim/placeholder-card-g.svg": 39403,
	"./decidim/placeholder-card-l.svg": 25664,
	"./decidim/placeholder.jpg": 19399,
	"./decidim/remixicon.symbol.svg": 27391,
	"./decidim/vendor/social-share-button/douban.svg": 73102,
	"./decidim/vendor/social-share-button/email.svg": 4011,
	"./decidim/vendor/social-share-button/facebook.svg": 15341,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 13879,
	"./decidim/vendor/social-share-button/hacker_news.svg": 29615,
	"./decidim/vendor/social-share-button/linkedin.svg": 16147,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 4828,
	"./decidim/vendor/social-share-button/pinterest.svg": 99421,
	"./decidim/vendor/social-share-button/reddit.svg": 97325,
	"./decidim/vendor/social-share-button/telegram.svg": 97460,
	"./decidim/vendor/social-share-button/tumblr.svg": 30971,
	"./decidim/vendor/social-share-button/twitter.svg": 55178,
	"./decidim/vendor/social-share-button/vkontakte.svg": 70132,
	"./decidim/vendor/social-share-button/wechat.svg": 68783,
	"./decidim/vendor/social-share-button/whatsapp.svg": 68975,
	"./decidim/vendor/social-share-button/x.svg": 45451,
	"./decidim/vendor/social-share-button/xing.svg": 2141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98531;